import { CircularProgress, Grid } from '@material-ui/core'

import React from 'react'

const Loading = () =>
  <Grid container alignContent="center" alignItems="center" >
    <CircularProgress style={{ margin: '0 auto', marginTop: 32, alignSelf: 'center' }} size={50} />
  </Grid>

export default Loading